import axios from 'axios';

function errorHandler(error, reject) {
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    posting(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`bankreval/posting/${obj.tgl1}/${obj.tgl2}`);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    postingUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.put(`bankreval/unposting/${obj.tgl1}/${obj.tgl2}`);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    printjv(obj = {}) {
        return new Promise(async (resolve, reject) => {
            let url;
            try {
                const keys = ['tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                url = `/bankreval/printjv`;
                url += str;
                const { data } = await axios.get(url);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    process(obj) {
        console.log('Proses Ap Reval : ',obj);
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bankreval${str}`;
                const { data } = await axios.get(url);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportxls(obj = {}) {
    return new Promise((resolve, reject) => {
        try {
            const keys = ['tgl1', 'tgl2'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            axios({
                url: `/bankreval/exportxls${str}`,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'bankreval_list.xlsx');
                document.body.appendChild(link);
                link.click();
                // window.location.assign(url);
                resolve(link);
            });

        } catch (error) {
            errorHandler(error, reject)
        }
    });
}    
};